import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/keyboard';
import 'swiper/css/autoplay';


console.log('test');

document.addEventListener('alpine:init', () => {
    Alpine.data('initPartners', () => ({
        open: false,
        swiper: {},
        init() {
            new Swiper(this.$refs.swiperContainer, {
                modules: [Navigation, Pagination, EffectFade],
                // Optional parameters
                direction: 'horizontal',
                loop: true,
                slidesPerView: 'auto',
                spaceBetween: 32,

                // Navigation arrows
                navigation: {
                    nextEl: this.$refs.btnNext,
                    prevEl: this.$refs.btnPrev,
                },


            })
        }
    }))
})